import { apiClient } from './client';

export async function getModuleSetupProfiles(params = {}) {
  const { data } = await apiClient.get('/api/system/mafertapp-module-setup-profiles', { params });
  return data;
}

export async function getModuleSetupProfile(id) {
  const { data } = await apiClient.get(`/api/system/mafertapp-module-setup-profiles/${id}`);
  return data.data;
}

export async function getModuleSetupProfileItems(id) {
  const { data } = await apiClient.get(`/api/system/mafertapp-module-setup-profiles/${id}/items`);
  return data;
}

export async function getTenantSetupProfileSummary(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/setup-profile-summary`, { params });
  return data.data;
}

export async function getTenantSetupWizardRequirements(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/setup-wizard-requirements`, { params });
  return data.data;
}

export async function getCustomerPortalSetupRequirements(customerId, tenantId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/tenants/${tenantId}/setup-requirements`);
  return data.data;
}
